import PropTypes from 'prop-types'
import Header from './Header'
import Footer from './Footer'

/**
 * Main layout component for the application
 * Wraps all pages with Header, main content, and Footer
 *
 * @component
 * @example
 * <MainLayout>
 *   <Head title="Page Title" />
 *   <div>Your page content</div>
 * </MainLayout>
 */
export default function MainLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <main className="flex-1">
        {children}
      </main>

      <Footer />
    </div>
  )
}

MainLayout.propTypes = {
  /** Page content */
  children: PropTypes.node.isRequired
}
